import { render, staticRenderFns } from "./RecognitionListEmptyState.vue?vue&type=template&id=076c34ea"
import script from "./RecognitionListEmptyState.vue?vue&type=script&lang=js"
export * from "./RecognitionListEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports